import { render } from "./PrivacyPolicyDetail.vue?vue&type=template&id=3c808da6&scoped=true"
import script from "./PrivacyPolicyDetail.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyDetail.vue?vue&type=script&lang=js"

import "./PrivacyPolicyDetail.vue?vue&type=style&index=0&id=3c808da6&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c808da6"]])

export default __exports__